// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"c4300096","63":"8a2bc58a","213":"042bb37f","453":"d855a71b","762":"25ab67e7","821":"0b9ad9f8"}[chunkId] + ".chunk.js";
};